import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PubNubAngular} from 'pubnub-angular2';
import {UserService} from 'app/core/user/user.service';
import {HttpClient} from '@angular/common/http';
import {DialogStyle40} from "@app/shared/classes/common";
import {CommonDataService, DefaultOrg, PubNubStatusCategory, SysParam} from '@app/shared';
import {ConnectService} from '@app/core/connect/connect.service';
import {forkJoin, Subscription} from 'rxjs';
import {GrowlService} from "@app/core";

@Component({
  selector: 'app-support-chat',
  templateUrl: './support-chat.component.html',
  styleUrls: ['./support-chat.component.css'],
  providers: [ConnectService, PubNubAngular]
})
export class SupportChatComponent implements OnInit, OnDestroy {

  DialogStyle40 = DialogStyle40;
  SupportMessageType: typeof SupportMessageType = SupportMessageType;
  SupportStatusType: typeof SupportStatusType = SupportStatusType;
  DefaultOrg: typeof DefaultOrg = DefaultOrg;

  chatList: SupportMessage[] = [];
  selectedSupportChat: SupportMessage = new SupportMessage();

  message: string;
  currentChannel: Channel = new Channel();
  displayProperty: DisplayProperty = new DisplayProperty();
  subscriptionList: string[] = [];
  supportRequestList: SupportMessage[] = [];
  sub: Subscription;
  // user: UserService;

  supportChatDialog = { display: false };
  globalDisplay: boolean = false;

  globalDialog: boolean;
  liveRequest = { count: 0 };

  @Output() handler: EventEmitter<any> = new EventEmitter();

  @Output() notificationHandler: EventEmitter<any> = new EventEmitter();

  @Input()
  set displayDialog(value: boolean) {
    if (value) {
      console.log(value);
      // this.supportChatDialog.display = value;
      // this.globalDisplay = true;
      this.openSupport();
    } else {
    }
  }


  constructor(public user: UserService, private growl: GrowlService,
              private http: HttpClient, private pubnub: PubNubAngular, private connectService: ConnectService, private commonDataService: CommonDataService) {
    // this.user = user;

    // pubnub.init({
    //   publishKey: 'pub-c-eb40606b-5559-4c93-beff-a8552464dc33',
    //   subscribeKey: 'sub-c-c2188530-f323-11e8-babf-1e3d8cb2a384',
    // });


    // forkJoin( //this.commonDataService.getEnum(EnumNames.revenueTypes)
    //   [this.commonDataService.getSysParams(SysParam.ConnectPubNubPublishKey), this.commonDataService.getSysParams(SysParam.ConnectPubNubSubscribeKey)])
    //   .subscribe(res => {
    //     console.log(res);
    //     let pubNubPublishKey = res[0].value;
    //     let pubNubSubscribeKey = res[1].value;

    //     pubnub.init({
    //       publishKey: pubNubPublishKey,
    //       subscribeKey: pubNubSubscribeKey,
    //     });
    //   });

    this.sub = UserService.userInfoObs.subscribe(auth => {
      if (auth) {
        this.initiateSupport();
        this.globalDisplay = true;

      }
    });
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.pubnub.unsubscribeAll();
  }

  initiateSupport() {
    forkJoin( //this.commonDataService.getEnum(EnumNames.revenueTypes)
      [this.commonDataService.getSysParams(SysParam.SupportPubNubPublishKey), this.commonDataService.getSysParams(SysParam.SupportPubNubSubscribeKey)])
      .subscribe(res => {
        let pubNubPublishKey = res[0].value;
        let pubNubSubscribeKey = res[1].value;

        this.pubnub.init({
          publishKey: pubNubPublishKey,
          subscribeKey: pubNubSubscribeKey,
        });
        if (this.user.managingOrgId == DefaultOrg.OrgId) {
          this.subscriptionList.push('oneLynkSupportMaster');
          this.pubnub.subscribe({
            channels: this.subscriptionList
          });
          console.log('subscribed to the list');
        }
        this.initiateChat(this.supportRequestList, this.user, this.chatList, this.displayProperty, this.currentChannel, this.liveRequest, this.supportChatDialog, this.notificationHandler, this.growl);
      });
  }

  onHideDialog(event) {
    this.handler.emit("closed");
  }

  sendMessage() {
    let time = this.timeNow();
    console.log(time);
    console.log(this.currentChannel.name);
    console.log(this.subscriptionList);
    const constructedMessage: SupportMessage = { message: this.message, time: time, fromUserId: this.user.info.userId, fromUserName: this.user.info.fullName, type: SupportMessageType.SupportMessage, fromOrgId: this.user.info.orgId, fromOrgName: this.user.info.orgName };
    this.pubnub.publish({ channel: this.currentChannel.name, message: constructedMessage }).then((response) => {
      console.log(response);
    }).catch((error) => {
      console.log(error);
    });
    this.message = '';
  }

  onClickBackToRequestsPage() {
    this.currentChannel.name = '';
    this.displayProperty.connected = false;
  }

  openSupport() {
    this.supportChatDialog.display = true;

    console.log(this.user.info);
    if (this.user.info.orgId != DefaultOrg.OrgId) {
      let channel = this.user.info.orgId.toString() + this.user.info.userId.toString() + this.user.info.fullName + '_oneLynkSupport';
      this.currentChannel.name = channel;
      // this.subscriptionList.push(channel);
      this.pubnub.subscribe({
        channels: [channel]
      });
      let supportRequest: SupportMessage = { fromOrgId: this.user.info.orgId, fromOrgName: this.user.info.orgName, fromUserId: this.user.info.userId, fromUserName: this.user.info.fullName, time: this.timeNow(), type: SupportMessageType.SupportRequest, channel: channel, status: SupportStatusType.Pending };
      console.log(supportRequest);
      this.pubnub.subscribe({
        channels: ['oneLynkSupportMaster']
      });
      this.pubnub.publish({ channel: 'oneLynkSupportMaster', message: supportRequest }).then((response) => {
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });
    }

    else if (this.user.info.orgId == DefaultOrg.OrgId) {
      this.liveRequest.count = 0;
      console.log(this.liveRequest.count);
      this.notificationHandler.emit(this.liveRequest.count);
    }
  }
  //Current time as string
  timeNow() {
    let d = new Date();
    return d.toString().substring(0, 25);
  }

  onSelectChat(supportRequest: SupportMessage) {
    this.currentChannel.name = supportRequest.channel;
    this.selectedSupportChat = supportRequest;
    this.changeData(this.chatList);
    this.displayProperty.connected = true;
  }

  deleteRequest(row) {
    let index = this.supportRequestList.findIndex(request => request.fromUserId == request.fromUserId);
    if (index > -1) {
      this.supportRequestList.splice(index, 1);
    }
  }

  onEndChat() {
    // this.playAudio();
    let supportEndMessage: SupportMessage = new SupportMessage();
    let channel: string = 'oneLynkSupportMaster';
    if (this.user && this.user.info && this.user.info.orgId != DefaultOrg.OrgId.valueOf()) { //Using comparison without valueOf() , is not letting the else message object to be set (throwing compilation issues , as it considers this.user.info.orgId to be of type DefaultOrg)
      if (!this.displayProperty.connected) {
        //If it is not connected , i.e still in wait state and the user tries to close the dialog , then send the chatEnd Message to the 'oneLynkSupportMaster' channel , because the
        //CSR wont be subscribed to the direct channel
        // supportEndMessage = { fromOrgId: this.user.info.orgId, fromOrgName: this.user.info.orgName, fromUserId: this.user.info.id, fromUserName: this.user.info.fullName, time: this.timeNow(), type: SupportMessageType.SupportEnd, channel: 'oneLynkSupportMaster', status: SupportStatusType.Pending };
        channel = 'oneLynkSupportMaster';
      }

      if (this.displayProperty.connected) {
        //If it is connected, i.e still in wait state and the user tries to close the dialog , then send the chatEnd Message to the direct channel , because the
        //CSR will be subscribed to the direct channel
        // supportEndMessage = { fromOrgId: this.user.info.orgId, fromOrgName: this.user.info.orgName, fromUserId: this.user.info.id, fromUserName: this.user.info.fullName, time: this.timeNow(), type: SupportMessageType.SupportEnd, channel: this.currentChannel.name, status: SupportStatusType.Pending };
        channel = this.currentChannel.name;
      }
    }
    else {
      // supportEndMessage = { fromOrgId: this.user.info.orgId, fromOrgName: this.user.info.orgName, fromUserId: this.user.info.id, fromUserName: this.user.info.fullName, time: this.timeNow(), type: SupportMessageType.SupportEnd, channel: this.currentChannel.name, status: SupportStatusType.Pending };
      channel = this.currentChannel.name;
      this.selectedSupportChat.status = SupportStatusType.Terminated;
    }


    supportEndMessage = { fromOrgId: this.user.info.orgId, fromOrgName: this.user.info.orgName, fromUserId: this.user.info.userId, fromUserName: this.user.info.fullName, time: this.timeNow(), type: SupportMessageType.SupportEnd, channel: channel, status: SupportStatusType.Pending };

    this.pubnub.publish({ channel: channel, message: supportEndMessage }).then((response) => {
      console.log(response);
      if (this.user.info.orgId != DefaultOrg.OrgId.valueOf()) {
        this.supportChatDialog.display = false;
      }
      this.displayProperty.connected = false;
    }).catch((error) => {
      console.log(error);
    });
    // }

  }

  //Dynamically changes data when a particular user/contact is clicked
  changeData(chatList) {

    console.log(this.currentChannel.name);
    function handleHistory(history) {
      for (const msg of history) {
        chatList.push(msg['entry']);
      }
    }
    this.chatList.length = 0;
    console.log('InchAat data');
    this.pubnub.history({
      channel: this.currentChannel.name,
      reverse: false, // false is the default
      count: 100, // 100 is the default
      stringifiedTimeToken: true // false is the default
    }).then((response) => {
      console.log(response['messages']);
      handleHistory(response['messages']);
    }).catch((error) => {
      console.log(error);
    });
  }

  publish() {

  }

  onClickVideoCall() {
    this.connectService.getZoomVideoURLV2('Support', 'nivas94@gmail.com', 'VIDEO').subscribe(res => {
      window.open(res.start_url, "_blank");

      let videoMessage: SupportMessage = { fromOrgId: this.user.info.orgId, fromOrgName: this.user.info.orgName, fromUserId: this.user.info.userId, fromUserName: this.user.info.fullName, time: this.timeNow(), type: SupportMessageType.Video, channel: this.currentChannel.name, message: res };
      this.pubnub.publish({ channel: this.currentChannel.name, message: videoMessage }).then((response) => {
      }).catch((error) => {
        console.log(error);
      });
    });

  }

  onClickVideoRequest(msg) {
    window.open(msg.join_url, "_blank");

  }

  playAudio() {
    let audio = new Audio();
    audio.src = "../../../assets/audio/to-the-point.mp3";

    audio.load();
    audio.play();
  }

  acceptRequest(supportRequest: SupportMessage) {
    this.subscriptionList.push(supportRequest.channel);
    this.pubnub.subscribe({
      channels: [supportRequest.channel]
    });
    let acceptanceMessage: SupportMessage = { fromOrgId: this.user.info.orgId, fromOrgName: this.user.info.orgName, fromUserId: this.user.info.userId, fromUserName: this.user.info.fullName, time: this.timeNow(), type: SupportMessageType.SupportAcceptance, channel: supportRequest.channel, status: SupportStatusType.Accepted, message: `Hi this is ${this.user.info.fullName}. Please Give a short description about the issue you are facing` };
    this.pubnub.publish({ channel: supportRequest.channel, message: acceptanceMessage }).then((response) => {
      console.log(response);
      supportRequest.status = SupportStatusType.Accepted;
      this.onSelectChat(supportRequest);
    }).catch((error) => {
      console.log(error);
    });
  }

  rejectRequest(supportRequest: SupportMessage) {
    // this.subscriptionList.push(supportRequest.channel);
    // this.pubnub.subscribe({
    //   channels: [supportRequest.channel]
    // });
    let rejectMessage: SupportMessage = { fromOrgId: this.user.info.orgId, fromOrgName: this.user.info.orgName, fromUserId: this.user.info.userId, fromUserName: this.user.info.fullName, time: this.timeNow(), type: SupportMessageType.SupportReject, channel: supportRequest.channel, status: SupportStatusType.Pending, message: 'All One Lynk Representatives are currently busy , please visit our help page or call us at xxx-xxx-xxxx' };
    this.pubnub.publish({ channel: supportRequest.channel, message: rejectMessage }).then((response) => {
      console.log(response);
      let index = this.supportRequestList.findIndex(supportRequest1 => supportRequest == supportRequest1);
      if (index > -1) {
        this.supportRequestList.splice(index, 1);
      }
    }).catch((error) => {
      console.log(error);
    });
  }


  //Initiates Pubnub, handles all incoming messages/requests/calls
  initiateChat(supportRequestList: SupportMessage[], user: UserService, chatList: SupportMessage[], displayProperty: DisplayProperty, currentChannel: Channel, liveRequest, supportChatDialog,
               notificationHandler: EventEmitter<any>, growl: GrowlService) {

    //console.log("CHAT INITIATED");


    function handleMessage(message) {
      const realMessage: SupportMessage = message['message'];
      console.log(realMessage);
      if (realMessage.type == SupportMessageType.SupportRequest && realMessage.fromUserId != user.info.userId && user.info.orgId == DefaultOrg.OrgId) {
        console.log('received a support request ' + realMessage.fromUserName);
        if (!supportChatDialog.display) {
          liveRequest.count = liveRequest.count + 1;
          console.log(liveRequest.count);
          notificationHandler.emit(liveRequest.count);
          let audio = new Audio();
          audio.src = "../../../assets/audio/to-the-point.mp3";

          audio.load();
          audio.play();
        }
        supportRequestList.push(realMessage);
        console.log(
          supportRequestList);
      }

      if (realMessage.type == SupportMessageType.SupportAcceptance && realMessage.fromUserId != user.info.userId && user.info.orgId != DefaultOrg.OrgId) {
        console.log('received a support acceptance ' + realMessage.fromUserName);
        let audio = new Audio();
        audio.src = "../../../assets/audio/to-the-point.mp3";

        audio.load();
        audio.play();
        chatList.push(realMessage);
        //unsubscribe the user from the support channel
        displayProperty.connected = true;

      }

      if (realMessage.type == SupportMessageType.SupportMessage) {
        console.log('received a support message from ' + realMessage.fromUserName);
        chatList.push(realMessage);
      }

      if (realMessage.type == SupportMessageType.SupportReject && user.info.orgId != DefaultOrg.OrgId) {
        console.log('received a support reject from ' + realMessage.fromUserName);
        chatList.push(realMessage);
        displayProperty.connected = true;
      }

      if (realMessage.type == SupportMessageType.Video && user.info.orgId != DefaultOrg.OrgId) {
        console.log('received a video link from ' + realMessage.fromUserName);
        chatList.push(realMessage);
      }

      if (realMessage.type == SupportMessageType.SupportEnd) {
        if (user.info.orgId == DefaultOrg.OrgId) {
          console.log('received a support end req from' + realMessage.fromUserName);
          if (currentChannel.name == realMessage.channel && currentChannel.name != 'oneLynkSupportMaster') {
            chatList.push({ message: '---User has left the chat---', type: SupportMessageType.SupportEnd });
          }
          let index = supportRequestList.findIndex(request => request.fromUserId == realMessage.fromUserId);
          if (index > -1) {
            // supportRequestList.splice(index, 1);
            supportRequestList[index].status = SupportStatusType.Terminated;
          }
        }
        else if (user.info.orgId != DefaultOrg.OrgId) {
          console.log('received a support end req from' + realMessage.fromUserName);
          if (displayProperty.connected) {
            chatList.push({ message: 'Support Person has left the Chat. Please contact us through phone or visit our help page', type: SupportMessageType.SupportEnd });
          }
          else {
          }

        }
      }
    }

    this.pubnub.addListener({
      status: function (statusEvent) {
        if ((statusEvent.category == PubNubStatusCategory.PNNetworkDownCategory) || (statusEvent.category == PubNubStatusCategory.PNNetworkIssuesCategory)) {
          console.log(statusEvent.category);
          // growl.add(GrowlType.Error, 'Network error, please contact Support');
          return;
        }
      },
      message: function (message) {
        console.log(message);
        handleMessage(message);
      }
    });
    this.pubnub.subscribe({
      channels: this.subscriptionList,
    });
  }

}

export class SupportMessage {
  fromOrgName?: string;
  fromOrgId?: number;
  fromUserId?: number;
  fromUserName?: string;
  toUserId?: number;
  toUserName?: string;
  toOrgId?: number;
  toOrgName?: string;
  type?: string;
  time?: string;
  message?: string;
  channel?: string;
  status?: string;
}

export enum SupportMessageType {
  SupportRequest = 'SUPPORT_REQUEST',
  SupportMessage = 'SUPPORT_MESSAGE',
  SupportAcceptance = 'SUPPORT_ACCEPTANCE',
  SupportEnd = 'SUPPORT_END',
  SupportReject = 'SUPPORT_REJECT',
  Video = 'VIDEO'
}

enum SupportStatusType {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Terminated = 'TERMINATED'
}

class Channel {
  name: string;
}

class DisplayProperty {
  connected: boolean = false;
}
